import { render, staticRenderFns } from "./ChangerLocale.vue?vue&type=template&id=968dcc4a&scoped=true&"
import script from "./ChangerLocale.vue?vue&type=script&lang=js&"
export * from "./ChangerLocale.vue?vue&type=script&lang=js&"
import style0 from "./ChangerLocale.vue?vue&type=style&index=0&id=968dcc4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968dcc4a",
  null
  
)

export default component.exports